// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3sIdD","bigColWidth":"Table_bigColWidth__1pkfg","biggerColWidth":"Table_biggerColWidth__1xdOE","row":"Table_row__32WKK","col":"Table_col__WI80X"};